// NGXS actions must stay newable classes: withActions/createDispatchMap in
// @res/ngg-core is typed over ActionDef, which requires a `new (...args)`
// signature, and the dispatcher matches action results by reference identity.
// The parameterless ones therefore carry a mirror instance field so they are
// not classes of statics only. NGXS resolves the type from constructor.type
// first, so the dispatched string is unchanged.
import { DateRangeType } from '@res/ng-data-access';
import { TypesaurusCoreDoc } from '@res/ngg-core';
import { AdvancedFilterModel, FilterModel, IServerSideGetRowsRequest } from 'ag-grid-community';
import { LosserAssignData, LosserModel, LosserRef } from '../../schema/schema.interface';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace LosserActions {
  export class GetAllLossers {
    static readonly type = '[Losser] GetAllLosser';
    readonly type = GetAllLossers.type;
  }

  export class InitLosserCount {
    static readonly type = '[Losser] InitLossersCount';
    readonly type = InitLosserCount.type;
  }

  export class InitLosser {
    static readonly type = '[Losser] InitLossers';
    readonly type = InitLosser.type;
  }
  export class CountLossers {
    static readonly type = '[Losser] CountLossers';
    readonly type = CountLossers.type;
  }

  export class CloseLossersConnection {
    static readonly type = '[Losser] CloseLossersConnection';
    readonly type = CloseLossersConnection.type;
  }

  export class GetLosserById {
    static readonly type = '[Losser] GetLosserById';
    readonly type = GetLosserById.type;
  }

  export class UpdateLosser {
    static readonly type = '[Losser] UpdateLosser';
    constructor(
      public losserData: Partial<LosserAssignData>,
      public ref: LosserRef,
    ) {}
  }

  export class DeleteLossers {
    static readonly type = '[Losser] DeleteLossers';
    constructor(public refs: LosserRef[]) {}
  }

  export class PaginateQueryLosser {
    static readonly type = '[Losser] PaginateQueryLosser';
    constructor(
      public request: IServerSideGetRowsRequest,
      public isResetAfterFilterOrSort = false,
      public userId?: string,
    ) {}
  }
  export class LosserError {
    static readonly type = '[Losser] LosserError';
    constructor(public error: Error) {}
  }

  export class GetSumOf {
    static readonly type = '[Losser] GetSumOf';
    constructor(
      public field: string,
      public timePeriod: DateRangeType,
    ) {}
  }
  export class GetSumsCountOf {
    static readonly type = '[Losser] GetSumsCountOf';
    constructor(
      public fields: {
        sumId: string;
        countId: string;
        countValue: number | string | boolean | Date;
      }[],
      public timePeriod: DateRangeType,
      public filterModel?: FilterModel | AdvancedFilterModel | null,
      public userId?: string,
    ) {}
  }

  export class UpdateLosserResult {
    static readonly type = '[Losser] UpdateLosserResult';
    constructor(public data: Array<TypesaurusCoreDoc<LosserModel> | null | undefined>) {}
  }
}
